<template>
  <div class="text-sm">
    <p class="mt-6"><b>2025.02.25</b> - Улучшения качества жизни Пещеры</p>
    <ul class="ml-5 pb-4 list-outside list-disc">
      <li>Теперь можно выбрасывать ненужный лут в Пещеры.</li>
      <li>
        Теперь доступно авто-исследование в Пещеры. Установите целевую глубину и позвольте своим отрядам бродить! (Вы просто не можете авто-спускаться глубже самого глубокого достигнутого уровня.)
      </li>
      <li>
        <div>Урон Пылающие руки увеличен:</div>
        <div>
          <code>65 + Уровень*(Об/3 + Ма/5 + Лв/7)</code> -->
          <code>65 + Уровень*(Об/2 + Ма/4 + Лв/6)</code>
        </div>
      </li>
      <li>(И куча исправлений багов.)</li>
    </ul>
  </div>
</template>
